// extracted by mini-css-extract-plugin
export var actions = "like-module--actions--f6bbe";
export var active = "like-module--active--f0230";
export var cta = "like-module--cta--b8c2a";
export var dislike = "like-module--dislike--7239f";
export var like = "like-module--like--1151b";
export var root = "like-module--root--3a11b";